import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const empty = { name: "", email: "", password: "", role: "journalist", bio: "" };

export default function UsersAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/users").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/register", form); toast.success("Usuário criado"); setForm(empty); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const remove = async (id) => { if (!window.confirm("Excluir?")) return; await api.delete(`/users/${id}`); load(); };

  const updateRole = async (u, role) => { await api.patch(`/users/${u.id}`, { role }); load(); };

  return (
    <AdminLayout>
      <div data-testid="admin-users">
        <h1 className="font-serif-display text-4xl font-bold">Usuários</h1>
        <p className="font-sans-ui text-sm text-zinc-500">Gerencie acessos: Administrador, Editor e Jornalista</p>
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          <form onSubmit={submit} className="border border-zinc-300 bg-white p-4 space-y-3" data-testid="user-form">
            <h2 className="overline">Novo usuário</h2>
            <input type="text" placeholder="Nome" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="user-name" />
            <input type="email" placeholder="E-mail" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="user-email" />
            <input type="password" placeholder="Senha (mín 6)" required minLength={6} value={form.password} onChange={e => setForm({...form, password: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="user-password" />
            <select value={form.role} onChange={e => setForm({...form, role: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm">
              <option value="journalist">Jornalista</option>
              <option value="editor">Editor</option>
              <option value="admin">Administrador</option>
            </select>
            <button type="submit" className="bg-black text-white px-4 py-2 w-full font-sans-ui text-sm uppercase tracking-widest font-semibold" data-testid="user-submit"><Plus size={14} className="inline mr-2"/>Criar</button>
          </form>
          <div className="md:col-span-2 border border-zinc-300 bg-white">
            <table className="w-full text-sm font-sans-ui">
              <thead className="bg-zinc-100"><tr className="text-left"><th className="p-3">Nome</th><th className="p-3">E-mail</th><th className="p-3">Permissão</th><th className="p-3"></th></tr></thead>
              <tbody>
                {items.map(u => (
                  <tr key={u.id} className="border-t border-zinc-200">
                    <td className="p-3 font-semibold">{u.name}</td>
                    <td className="p-3 text-zinc-600">{u.email}</td>
                    <td className="p-3">
                      <select value={u.role} onChange={e => updateRole(u, e.target.value)} className="border border-zinc-300 px-2 py-1 text-xs">
                        <option value="journalist">Jornalista</option>
                        <option value="editor">Editor</option>
                        <option value="admin">Administrador</option>
                      </select>
                    </td>
                    <td className="p-3">
                      <button onClick={() => remove(u.id)} className="p-1.5 border border-zinc-300 text-red-700"><Trash2 size={14}/></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
